const dropContainer = {
  scheduledServiceTitle: 'Serviço Agendado',
  scheduledServicesTitle: 'Serviços Agendados',  
  scheduledServiceDoneTitle: 'Serviço realizado',
  scheduledServicesDoneTitle: 'Serviços realizados',
};

export default dropContainer;
